import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './StepsCount.theme.scss';

function StepsCount({ className, value = 0, displayLabel = true }) {
  const isMultiStep = value > 1;

  return (
    <div className={cn('steps-count', { 'steps-count--multistep': isMultiStep }, className)}>
      {displayLabel && <p className="steps-count__label">{`${value} step${isMultiStep ? 's' : ''}`}</p>}
      <svg className="steps-count__icon els-btn-icon icon-arrow-results">
        <use xlinkHref={isMultiStep ? '#icon-arrow-results' : '#icon-arrow'} />
      </svg>
    </div>
  );
}

StepsCount.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number,
  displayLabel: PropTypes.bool,
};

export default StepsCount;
